import { Topic, Post } from '../../types/forum';
import { getUserById } from '../users';

export const categoryId = '3';
export const categoryName = "Annual Search Party";
export const categoryDescription = 'The annual search party occurs in Autumn when it is most likely for a sighting. Search participants begin at dawn and circle the lake as a group 10 times (approx. 26 miles!), leaving on the hour every hour looking for signs of Goosifer.';

// Helper function to generate topic IDs within this category
const makeTopicId = (localId: number) => `${categoryId}-${localId}`;
const makePostId = (topicLocalId: number, postLocalId: number) => `${categoryId}-${topicLocalId}-${postLocalId}`;

export const topics: Topic[] = [
  {
    id: makeTopicId(1),
    title: 'Search Party Overview',
    description: 'Essential information about the annual Search Party',
    categoryId: '3',
    authorId: '6',
    author: getUserById('6')!,
    createdAt: '2021-08-30T08:00:00Z',
    lastPostAt: '2024-12-15T16:00:00Z',
    postCount: 1,
    viewCount: 2341,
    isSticky: true
  },
  {
    id: makeTopicId(2),
    title: '2021 Search Party On Hold',
    categoryId: '3',
    authorId: '6',
    author: getUserById('6')!,
    createdAt: '2021-08-30T10:00:00Z',
    lastPostAt: '2021-09-15T18:30:00Z',
    postCount: 1,
    viewCount: 445,
    isAnnouncement: false
  },
  {
    id: makeTopicId(3),
    title: '2022 Search Party On Hold',
    categoryId: '3',
    authorId: '6',
    author: getUserById('6')!,
    createdAt: '2022-08-25T14:20:00Z',
    lastPostAt: '2022-08-25T14:20:00Z',
    postCount: 1,
    viewCount: 234,
    isAnnouncement: false
  },
  {
    id: makeTopicId(4),
    title: '2023 Search Party Announced',
    categoryId: '3',
    authorId: '6',
    author: getUserById('6')!,
    createdAt: '2023-08-20T11:00:00Z',
    lastPostAt: '2023-09-10T16:45:00Z',
    postCount: 1,
    viewCount: 678,
    isAnnouncement: false
  },
  {
    id: makeTopicId(5),
    title: '2023 Search Party Success!',
    categoryId: '3',
    authorId: '6',
    author: getUserById('6')!,
    createdAt: '2023-09-15T20:30:00Z',
    lastPostAt: '2023-09-20T12:15:00Z',
    postCount: 1,
    viewCount: 892,
    isAnnouncement: false
  },
  {
    id: makeTopicId(6),
    title: '2024 Search Party Announced',
    categoryId: '3',
    authorId: '6',
    author: getUserById('6')!,
    createdAt: '2024-08-18T09:30:00Z',
    lastPostAt: '2024-09-05T17:20:00Z',
    postCount: 1,
    viewCount: 567,
    isAnnouncement: false
  },
  {
    id: makeTopicId(7),
    title: '2024 Search Party Success!',
    categoryId: '3',
    authorId: '6',
    author: getUserById('6')!,
    createdAt: '2024-09-12T21:15:00Z',
    lastPostAt: '2024-09-18T13:40:00Z',
    postCount: 1,
    viewCount: 945,
    isAnnouncement: false
  },
  {
    id: makeTopicId(8),
    title: '2025 Search Party Cancelled',
    categoryId: '3',
    authorId: '6',
    author: getUserById('6')!,
    createdAt: '2025-06-21T10:00:00Z',
    lastPostAt: '2025-06-21T10:00:00Z',
    postCount: 1,
    viewCount: 123,
    isAnnouncement: true
  }
];

export const posts: Post[] = [
  // Search Party Overview
  {
    id: makePostId(1, 1),
    topicId: makeTopicId(1),
    authorId: '6',
    author: getUserById('6')!,
    content: `<h2>DETAILS</h2>

<p>The annual search party was held at Sloan's Lake in Denver, Colorado in 2023 and 2024. It is currently on hold indefinitely as of 2025.</p>

<p>Did you know that the loop around Sloan's Lake is almost perfectly 2.62 miles around? We circled the lake on the hour, every hour for 10 hours as we completed a Marathon around the lake (10 x 2.62 = 26.2!).</p>

<p>Everyone started at the same time every hour and had 1 hour to complete the loop around the lake. You could run, walk, crawl as long as you made it back within an hour. Though the sooner you finished the sooner you could hang out at the basecamp with friends, family, food, and fun! This is unlike other races where your support squad may only see you sweat past them for a brief second or two as they wave smart handmade signs and you work up a quick smile for their support. Instead you would get to see them every time you completed a loop! This made for a very unique and shared experience! Interested?</p>

<p>Goosifer was most likely to be in this area in Autumn but the exact date would vary depending on latest information available from sightings and tracking efforts.</p>

<p><strong>WHEN:</strong> Autumn. Exact date would vary year to year.<br>
<strong>START TIME:</strong> 0700 or just after dawn<br>
<strong>END TIME:</strong> 1800 unless the creature causes havoc<br>
<strong>BASECAMP LOCATION:</strong> Basecamp was setup at Sloan's Lake, exact location TBD.</p>

<h2>THE SEARCH</h2>

<p>Why is this called a search? That is the other thing that makes this an even more unusual event. There have been constant reports of the mythical creature Goosifer roaming around Sloan's Lake - something with the head of a goose and body of bigfoot. We went out as a group in search of evidence of Goosifer. Each participant needed to check-in at basecamp after searching the lake (completing a loop) within an hour, for safety purposes of course!</p>

<h3>Ground Rules</h3>
<ul>
<li>The entire group left basecamp together at the beginning of every hour. We left at the same time but you could return as quickly as you wanted.</li>
<li>Each participant needed to complete a full search (loop) around the lake (approx 2.62 miles)</li>
<li>Each participant needed to return back to basecamp within an hour and check-in with an organizer</li>
<li>Each participant completed 10 full loops around the lake (approx 26.2 miles). That meant you'd be out there for 10+ hours no matter how fast you normally run a marathon.</li>
</ul>

<h2>THE PARTY</h2>

<p>The race began and ended at basecamp. This is where each participant needed to sign-in to start and check-in every hour. Friends, family, and foes were welcome to make camp here as well and spend the day at beautiful Sloan's Lake. There was water, coffee, some sustenance, and other surprises at basecamp; however, participants must be radically self-reliant! At the end we celebrated a long day of searching around the lake. Those who successfully completed the full 10 loops were rewarded and the top search participants were recognized for their hard work!</p>

<h3>Here are some things participants were encouraged to bring and not bring to the party:</h3>

<h4>DO BRING:</h4>
<ul>
<li>Wear appropriate attire to complete 10 searches around the lake ~ 26 miles in total. That's a marathon of monster hunting!</li>
<li>Bring nutrition and electrolytes to keep you going strong</li>
<li>Bring a headlamp or flashlight for the start and end of the search</li>
<li>Bring shelter (pop-ups, tent, umbrella) so you can be protected from the elements throughout the long day</li>
<li>DO BRING friends, family, and any creature comforts that will make this an amazing and memorable day!</li>
</ul>

<h4>DO NOT BRING:</h4>
<ul>
<li>DO NOT BRING any weapons or anything else that could get yourself or others hurt!</li>
</ul>`,
    timestamp: '2021-08-30T08:00:00Z'
  },
  // 2021 Search Party On Hold
  {
    id: makePostId(2, 1),
    topicId: makeTopicId(2),
    authorId: '6',
    author: getUserById('6')!,
    content: `<h2>2021 Search Party On Hold</h2>

<p>Due to COVID-19 and the ongoing challenges of organizing large gatherings, the 2021 Sloan's Lake Search Party is on hold. We are continuing to do recon and research to ensure that when we do host the event, it will be safe and effective for everyone involved.</p>

<p>Stay tuned for updates as we continue to prepare for the first ever Sloan's Lake Search Party!</p>`,
    timestamp: '2021-08-30T10:00:00Z'
  },
  // 2022 Search Party On Hold
  {
    id: makePostId(3, 1),
    topicId: makeTopicId(3),
    authorId: '6',
    author: getUserById('6')!,
    content: `<h2>2022 Search Party On Hold</h2>

<p>Due to COVID-19 and the ongoing challenges of organizing large gatherings, the 2022 Sloan's Lake Search Party is still on hold. We are continuing to do recon and research to ensure that when we do host the event, it will be safe and effective for everyone involved. We are eager to get searching in 2023!</p>`,
    timestamp: '2022-08-25T14:20:00Z'
  },
  // 2023 Search Party Announced
  {
    id: makePostId(4, 1),
    topicId: makeTopicId(4),
    authorId: '6',
    author: getUserById('6')!,
    content: `<h2>2023 Inaugural Sloan's Lake Search Party (SLSP) Announced!</h2>

<p>The 2023 Inaugural Sloan's Lake Search Party (SLSP) will be held on <strong>Saturday, Sep 2 2023</strong>!</p>

<p>Sign-up here: <a href="https://runsignup.com/Race/CO/Denver/SLSP" target="_blank">https://runsignup.com/Race/CO/Denver/SLSP</a></p>

<p>Want to help organize our very first event? Fill out this form: <a href="https://forms.gle/RaU84YSnb3y1wYuR9" target="_blank">https://forms.gle/RaU84YSnb3y1wYuR9</a></p>`,
    timestamp: '2023-08-20T11:00:00Z'
  },
  // 2023 Search Party Success
  {
    id: makePostId(5, 1),
    topicId: makeTopicId(5),
    authorId: '6',
    author: getUserById('6')!,
    content: `<h2>2023 Search Party Success!</h2>

<p>The first ever Sloan's Lake Search Party (SLSP) held on September 2, 2023 was a great success! We even caught Goosifer but unfortunately they escaped and are back on the loose. We are now in the process of organizing a 2024 Search Party so stay tuned for details!</p>

<p>Photos from the Search Party and of Goosifer (or what may have actually been a guy dressed like Goosifer) can be viewed here:<br>
<a href="https://runsignup.com/Race/SLSP/Page/2023Photos" target="_blank">https://runsignup.com/Race/SLSP/Page/2023Photos</a></p>`,
    timestamp: '2023-09-15T20:30:00Z'
  },
  // 2024 Search Party Announced
  {
    id: makePostId(6, 1),
    topicId: makeTopicId(6),
    authorId: '6',
    author: getUserById('6')!,
    content: `<h2>2024 Sloan's Lake Search Party (SLSP) Announced!</h2>

<p>The 2024 Sloan's Lake Search Party (SLSP) will be held on <strong>Saturday, Sep 7 2024</strong>!</p>

<p>Sign-up here: <a href="https://runsignup.com/Race/CO/Denver/SLSP" target="_blank">https://runsignup.com/Race/CO/Denver/SLSP</a></p>

<p>Want to help organize? Please fill out this form: <a href="https://forms.gle/RaU84YSnb3y1wYuR9" target="_blank">https://forms.gle/RaU84YSnb3y1wYuR9</a></p>`,
    timestamp: '2024-08-18T09:30:00Z'
  },
  // 2024 Search Party Success
  {
    id: makePostId(7, 1),
    topicId: makeTopicId(7),
    authorId: '6',
    author: getUserById('6')!,
    content: `<h2>2024 Search Party Success!</h2>

<p>Our 2nd annual Sloan's Lake Search Party (SLSP) was another successful event! We had lots to celebrate this year including capturing Goosifer again (I'm happy to report he has not yet escaped!).</p>

<p>Congrats to everyone who participated this year! You all did a great job! Hope to see y'all again next year!</p>

<p>2024 Search Recap here: <a href="https://runsignup.com/Race/SLSP/Page/2024" target="_blank">https://runsignup.com/Race/SLSP/Page/2024</a></p>`,
    timestamp: '2024-09-12T21:15:00Z'
  },
  // 2025 Search Party Cancelled
  {
    id: makePostId(8, 1),
    topicId: makeTopicId(8),
    authorId: '6',
    author: getUserById('6')!,
    content: `<h2>2025 Search Party Cancelled</h2>

<p>We have some unfortunate news to share. After two amazing years of the Sloan's Lake Search Party (SLSP), we've been officially notified by the government that our "unofficial official" search party is not allowed to continue, at least not in its current form and not at Sloan's Lake.</p>

<p>As a result, the 3rd Annual SLSP, originally scheduled for Sunday, September 14, 2025, is officially <strong>CANCELLED</strong>. The event as a whole is on hold indefinitely.</p>

<p>There was always a risk this might happen. This all started as a strange idea to run 10 loops around Denver's largest lake that just happens to be nearly perfectly 1/10th of a marathon. All in search of the mythical creature Goosifer aka the Colfax Creature and Sloan's Lake Monster.</p>

<p>As for the future, we're not sure yet. Goosifer and the powers that be got the best of us this year. But we're still determined to figure out how to keep the search alive. If we do, you'll be the first to know.</p>`,
    timestamp: '2025-01-15T10:00:00Z'
  }
]; 